<template>
    <footer class="footer bg-sky-900 text-white">
      <div class="container px-4 grid grid-cols-1 md:grid-cols-3 gap-8 py-6 mx-6 sm:mx-auto">
        <!-- Left Column: Logo and Slogan -->
        <div class="md:text-center text-left">
          <h3 class="text-2xl font-bold mb-4">Visspecialist van Wijk</h3>
          <p class="text-white">Het juiste adres voor verse vis en zeevruchten.</p>
        </div>
        <!-- Middle Column: Links -->
        <div class="md:text-center text-left">
          <h3 class="text-xl font-bold mb-4">Handige Links</h3>
          <ul class="space-y-2">
            <li><a href="#assortiment" class="text-white hover:underline">Assortiment</a></li>
            <li><a href="#over-ons" class="text-white hover:underline">Over ons</a></li>
            <li><a href="#contact" class="text-white hover:underline">Contact</a></li>
          </ul>
        </div>
        <!-- Right Column: Socials -->
        <div class="md:text-center text-left">
    <h3 class="text-xl font-bold mb-4">Neem Contact Op</h3>
    <div class="flex md:justify-center space-x-4">
      <a href="mailto:info@visspecialistvanwijk.nl" class="text-white hover:text-white flex items-center space-x-2">
        <i class="fas fa-envelope fa-lg"></i>
        <span>Mail ons</span>
      </a>
      <a href="tel:0135713106" class="text-white hover:text-white flex items-center space-x-2">
        <i class="fas fa-phone fa-lg"></i>
        <span>Bel ons</span>
      </a>
    </div>
  </div>
  
      </div>
      <!-- Footer Note -->
      <div class="bg-sky-950 text-center text-white py-4">
        <p>
          Website ontwikkeld door
          <a href="https://www.launch-media.nl" class="text-teal-100 font-bold hover:underline">Launch Media</a>
        </p>
      </div>
    </footer>
  </template>
  
  <script>
  export default {
    name: "FooterComponent",
  };
  </script>
  